<template>
  <sdCards :title="$t('pages.apps.inputs.new-title')">
    <a-form layout="vertical" :model="formData" @submit="handleSubmit">
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-item :label="$t('common.type')">
            <a-select v-model:value="formData.xtype" required>
              <a-select-option value="textfield">{{ $t('pages.apps.inputs.textfield') }}</a-select-option>
              <a-select-option value="textarea">{{ $t('pages.apps.inputs.textarea') }}</a-select-option>
              <a-select-option value="numberfield">{{ $t('pages.apps.inputs.numberfield') }}</a-select-option>
              <a-select-option value="combobox">{{ $t('pages.apps.inputs.combobox') }}</a-select-option>
              <a-select-option value="checkbox">{{ $t('pages.apps.inputs.checkbox') }}</a-select-option>
              <a-select-option value="fileSelect">{{ $t('pages.apps.inputs.fileSelect') }}</a-select-option>
              <a-select-option value="colorfield">{{ $t('pages.apps.inputs.colorfield') }}</a-select-option>
              <a-select-option value="date">{{ $t('pages.apps.inputs.date') }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label="$t('common.title')">
            <a-input :placeholder="$t('common.title')" v-model:value="formData.fieldLabel" required />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label="$t('common.key')">
            <a-input :placeholder="$t('common.key')" v-model:value="formData.name" required />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label="$t('pages.apps.inputs.default-value')">
            <a-input :placeholder="$t('pages.apps.inputs.default-value')" v-model:value="formData.value" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label="$t('pages.apps.inputs.required')">
            <a-switch v-model:checked="formData.required" />
          </a-form-item>
        </a-col>
      </a-row>
      <a-form-item :label="$t('pages.apps.inputs.select-option')" v-if="formData.xtype == 'combobox'">
        <a-row :gutter="16" v-for="(option, index) in formData.options" :key="index">
          <a-col :span="10">
            <a-form-item :label="$t('common.value')">
              <a-input :placeholder="$t('common.value')" v-model:value="option.value" required />
            </a-form-item>
          </a-col>
          <a-col :span="10">
            <a-form-item :label="$t('pages.apps.inputs.text')">
              <a-input :placeholder="$t('pages.apps.inputs.text')" v-model:value="option.name" required />
            </a-form-item>
          </a-col>
          <a-col :span="4">
            <a-form-item :label="$t('common.action')">
              <sdButton size="default" type="danger" @click.prevent="deleteOption(index)">
                <sdFeatherIcons type="trash-2" size="14" /> <span>{{ $t('common.remove') }}</span>
              </sdButton>
            </a-form-item>
          </a-col>
        </a-row>
        <sdButton size="small" type="success" @click.prevent="addOption">
          <sdFeatherIcons type="plus" size="14" /> <span>{{ $t('common.add-new') }}</span>
        </sdButton>
      </a-form-item>
      <a-form-item>
        <a-button :loading="iconLoading" type="primary" htmlType="submit"> {{ $t('common.save') }} </a-button>
      </a-form-item>
    </a-form>
  </sdCards>
</template>

<script>
export default {
  name: 'InstallScreenNew',
  data() {
    return {
      iconLoading: false,
      formData: {
        app_id: this.$route.params.id,
        xtype: 'textfield',
        fieldLabel: null,
        name: null,
        required: true,
        value: null,
        options: [
          {
            value: 'value',
            name: 'name',
          },
        ],
      },
    };
  },
  methods: {
    addOption() {
      this.formData.options.push({
        value: null,
        name: null,
      });
    },
    deleteOption(index) {
      if (this.formData.options.length > 1) {
        this.formData.options.splice(index, 1);
      } else {
        this.$message.error(this.$t('pages.apps.inputs.not-delete'));
      }
    },
    handleSubmit() {
      this.iconLoading = true;
      this.$appAxios.post(this.$endpoints.app_inputs_set, this.formData).then((resp) => {
        if (resp.data.status) {
          this.$message.success(this.$t('common.success-message'));
          this.$router.push({ name: 'detail-inputs' });
        } else {
          this.$message.error(resp.data.message);
          this.iconLoading = false;
        }
      });
    },
  },
  mounted() {},
};
</script>